import { _useEventDispatch, _useOnEvent } from './EventEmitter.hooks.js';

const useEventDispatch = _useEventDispatch;
const useOnEvent = _useOnEvent;

export { useEventDispatch, useOnEvent };
